import { DialogTrigger } from 'react-aria-components';
import { ModalTrigger } from './ModalTrigger';
import * as Styled from './Modal.styled';
import type { ModalProps } from './types';

export const Modal = ({
  children,
  isCarouselCta = false,
  isLinkLike = false,
  onOpenChange,
  trigger,
}: ModalProps) => (
  <DialogTrigger onOpenChange={onOpenChange}>
    <ModalTrigger
      isCarouselCta={isCarouselCta}
      isLinkLike={isLinkLike}
      trigger={trigger}
    />
    <Styled.Overlay onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
      <Styled.OverlayContent>{children}</Styled.OverlayContent>
    </Styled.Overlay>
  </DialogTrigger>
);
